<template>
    <div class="float-left mr-1" v-if="convenio.idSituacaoConvenio != 9">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Cronograma de Desembolso"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <cronograma-desembolso-form
            operacaoProp="A"
            :cronogramaDesembolso="cronogramaDesembolso"
            :mostrarModal="mostrarModal"
            :erros="erros"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></cronograma-desembolso-form>
    </div>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'
import CronogramaDesembolsoForm from './CronogramaDesembolsoForm'

export default {
    components: {
        CronogramaDesembolsoForm
    },

    props: {
        convenio: Object,
        cronogramaDesembolso: Object
    },

    data() {
        return {
            mostrarModal: false,
            erros: []
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(cronogramaDesembolso) {
            this.$store.dispatch('addRequest')
            let cronogramaDesembolsoDto = {
                idConvenio : this.$route.params.convenioId,
                codSituacao: cronogramaDesembolso.codSituacao,
                dtLiberacao:cronogramaDesembolso.dtLiberacao,
                dtMesAno:cronogramaDesembolso.dtMesAno,
                idCronogramaDesembolso:cronogramaDesembolso.idCronogramaDesembolso,
                nuParcela:cronogramaDesembolso.nuParcela,
                nuValorDesembolso:cronogramaDesembolso.nuValorDesembolso,
                percExecucao:cronogramaDesembolso.percExecucao,
                vcDescricao:cronogramaDesembolso.vcDescricao,
                vlLiberado:cronogramaDesembolso.vlLiberado,
                temComprometimento: cronogramaDesembolso.temComprometimento
            }
            ConveniosServicos.AlterarCronogramaDesembolso(cronogramaDesembolsoDto).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Cronograma atualizado com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarLista')
                        this.fecharModal()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
